import { fileUpload, getRequest, postRequest } from './request'

//获取OTA列表
export function getOtaList(page, size, projectId) {
  return getRequest('/ota/list', {
    'projectId': projectId,
    'page': page,
    'size': size
  })
}

//获取OTA文件URL
export function getOtaFileUrl(fileName) {
  return getRequest('/ota/file/url', { 'fileName': fileName })
}

//删除OTA
export function deleteOta(data) {
  return postRequest('/ota/delete', data)
}

export function createOta(otaForm) {
  return fileUpload('/ota/create', otaForm)
}

export function editOta(otaForm) {
  return postRequest('/ota/edit', otaForm)
}

export function modifyOta(otaForm) {
  return postRequest('/ota/modify', otaForm)
}


//发送通知
export function sendNotify(otaId, snList, versionList) {
  return postRequest('/ota/notify', {
    'otaId': otaId,
    'snNumbers': snList,
    'versions': versionList
  })
}

//获取所有版本号
export function getVersion(otaId) {
  return getRequest('/ota/versions', {
    'version': otaId,
  })
}

//获取所有sn号
export function getSN() {
  return getRequest('/project/snnumbers', {
  })
}

export function getOtaConfList(proNumber) {
  return getRequest('/ota/conf/list', { proNumber })
}

export function otaConfAdd(conf) {
  return postRequest('/ota/conf/add', conf)
}

export function otaConfDel(ids) {
  return postRequest('/ota/conf/del', { id: ids })
}
